import { http } from "./http";
import { GET_COMMISSION_BY_PAYMENT_ID_URL, GET_COMMISSION_PROFIT_DETAIL_BY_INVOICE_ID_URL, UPDATE_COMMISSION_PROFIT_COSTS_URL } from "./URL";

export const commissionDetailByPaymentId = async (paymentId: number) => {
    try {
      const response = await http.get(`${GET_COMMISSION_BY_PAYMENT_ID_URL}?paymentId=${paymentId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

export const getCommissionProfitDetailByInvoiceId = async (invoiceId: number) => {
  try {
    const response = await http.get(`${GET_COMMISSION_PROFIT_DETAIL_BY_INVOICE_ID_URL}?invoiceId=${invoiceId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export type UpdateCommissionProfitCostsRequest = {
  invoiceId: number;
  cogsAmount?: number;
  shippingChargesActual?: number;
};

export const updateCommissionProfitCosts = async (payload: UpdateCommissionProfitCostsRequest) => {
  try {
    const response = await http.post(UPDATE_COMMISSION_PROFIT_COSTS_URL, payload);
    return response;
  } catch (error) {
    throw error;
  }
};